// extracted by mini-css-extract-plugin
export default {"container":"WecomAppInfo_container__QMlQT"};